"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Consumer = exports.Provider = exports.CalendarContext = void 0;

var _react = _interopRequireDefault(require("react"));

var CalendarContext = /*#__PURE__*/_react["default"].createContext();

exports.CalendarContext = CalendarContext;
var Provider = CalendarContext.Provider,
    Consumer = CalendarContext.Consumer;
exports.Consumer = Consumer;
exports.Provider = Provider;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-rainbow-components/components/Calendar/context.js
// module id = erqO
// module chunks = 0